import React from 'react';
import { Modal } from '../../../components/common/Modal';

export const ReportsMenu = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Reports">
      <div className="p-6">
        <p className="text-gray-300">Reports functionality coming soon...</p>
      </div>
    </Modal>
  );
};